function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgBrokenLinks = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M 17.460938 27 C 16.359375 28.226563 14.773438 29 13 29 L 10 29 C 6.691406 29 4 26.308594 4 23 C 4 19.691406 6.691406 17 10 17 L 13 17 C 14.773438 17 16.359375 17.773438 17.460938 19 L 22.160156 19 C 20.613281 15.472656 17.09375 13 13 13 L 10 13 C 4.484375 13 0 17.484375 0 23 C 0 28.515625 4.484375 33 10 33 L 13 33 C 17.09375 33 20.613281 30.527344 22.160156 27 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1976D2"
    },
    d: "M 38 13 L 35 13 C 30.90625 13 27.386719 15.472656 25.84375 19 L 30.539063 19 C 31.640625 17.773438 33.230469 17 35 17 L 38 17 C 41.308594 17 44 19.691406 44 23 C 44 26.308594 41.308594 29 38 29 L 35 29 C 33.230469 29 31.640625 28.226563 30.539063 27 L 25.84375 27 C 27.386719 30.527344 30.90625 33 35 33 L 38 33 C 43.515625 33 48 28.515625 48 23 C 48 17.484375 43.515625 13 38 13 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BCD4"
    },
    d: "M 19.472656 4 L 16 5.984375 L 22.054688 14.089844 L 23.378906 13.332031 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BCD4"
    },
    d: "M 28.527344 4 L 32 5.984375 L 25.945313 14.089844 L 24.621094 13.332031 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BCD4"
    },
    d: "M 28.527344 44 L 32 42.015625 L 25.945313 33.910156 L 24.621094 34.667969 Z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BCD4"
    },
    d: "M 19.472656 44 L 16 42.015625 L 22.054688 33.910156 L 23.378906 34.667969 Z "
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrokenLinks, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/broken-links.3ee94aed.svg";
export { ForwardRef as ReactComponent };